export default "__VITE_ASSET__D77q8Drv__"